import React from 'react'

import everybodyElse from '../../images/EVERYBODY-ELSE-IS-TAKEN.png'

function EverybodyElseIsTaken() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={everybodyElse}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Everybody Else Is Taken</h1>
          <p className="Project-text">
            <strong>
            Short Film
            <br />

Director: Jessica Grace Smith
            <br />
            2015
            <br />
            <br />

Rehearsal + On Set Acting Coach
            <br />
Coached lead actor (age 13) and supporting cast (ages 11-14)

            </strong>
          </p>
          <p className="Project-testimonial">
            "Ella was a godsend while shooting my short, Everybody Else Is Taken. When working with
children it's so important to keep their energy focussed so they don't tire out, and our 13
year old lead, Gala Baumfield, was working 10 hour days and in every scene of the
movie. Ella developed a rapport with Gala immediately, she used different techniques and
games over the four-day shoot to get the actors connected to each other, and was great at
helping integrate my direction into these games. Having Ella on set really freed me up to
work with the crew between scenes, especially on some of the more technical stuff that was
new to me as a first time director, and I knew Gala still felt held and supported when I
needed to be making decisions elsewhere. I would definitely have her back to my next
project!
”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Jessica Grace Smith –director</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default EverybodyElseIsTaken
